import { render } from "./TextListRenderer.vue?vue&type=template&id=280e6966&scoped=true"
import script from "./TextListRenderer.vue?vue&type=script&lang=js"
export * from "./TextListRenderer.vue?vue&type=script&lang=js"

import "./TextListRenderer.vue?vue&type=style&index=0&id=280e6966&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280e6966"]])

export default __exports__